import { ApiResponse } from './api';

export enum ProductStatus {
  COMING_SOON = 'COMING_SOON',
  OPERATIONAL = 'OPERATIONAL',
  DISABLED = 'DISABLED',
  IS_PREMIUM = 'IS_PREMIUM',
}

export enum ProductTypeFileTypeEnum {
  FACT_SHEET = 'Fact Sheet',
  SHARIA_CERTIFICATE = 'Sharia certificate',
}

export interface ProductTypeFileType {
  id: number;
  name: ProductTypeFileTypeEnum;
}

export interface ProductTypeFile {
  id: number;
  documentLink: string;
  fileType: number;
}

/** Index fund linked to a product type (from GET .../index-fund/options — selected funds for that product type). */
export interface ProductTypeSelectedIndexFund {
  id: number;
  nameEn: string;
  nameAr: string;
  code: string;
}

export type ProductType = {
  id: number | undefined;
  nameEn: string;
  nameAr: string;
  descriptionEn: string;
  descriptionAr: string;
  disabled: boolean;
  scoreDependent: boolean;
  isCustom: boolean;
  fee: number;
  files: ProductTypeFile[];
  indexFunds?: number[];
  productStatus?: ProductStatus;
  createdAt: Date | string;
  updatedAt: Date | string;
};

export type UpdateProductTypeFile = Optional<ProductTypeFile, 'id'>;

export type FetchProductTypeResponse = ApiResponse<ProductType>;
export type FetchProductTypesResponse = ApiResponse<{ items: ProductType[]; totalItems: number }>;

export type CreateProductTypeRequest = Omit<ProductType, 'createdAt' | 'updatedAt'>;
export type CreateProductTypeResponse = ApiResponse<ProductType>;

export type UpdateProductTypeRequest = Omit<ProductType, 'createdAt' | 'updatedAt'>;
export type UpdateProductTypeResponse = ApiResponse<ProductType>;

export type FetchProductTypeFileTypeOptionsResponse = ApiResponse<ProductTypeFileType[]>;
export type FetchProductTypeSelectedIndexFundsResponse = ApiResponse<
  ProductTypeSelectedIndexFund[] | { items: ProductTypeSelectedIndexFund[]; totalItems?: number }
>;
